export default __webpack_public_path__ + "static/media/mic-grey.96a3f9c6.svg";